// Only the 403 status counts: a 401 is a real authentication failure and keeps its own handling.
const isAccessDenied = (err) => err?.response?.status === 403;

export default isAccessDenied;
